import {useCallback, useState} from 'react';

import {
  clearFocused,
  isElementVisible,
  scrollIntoView,
  setFocusedAttribute,
} from '../../../../../../srcCommon/inboxes/search/searchAttributesHelpers';

export const useHighlightedMatchesFrontEndOnly = () => {
  const [highlightedElements, setHighlightedElements] = useState<ReadonlyArray<Element>>([]);
  const [matchIndex, setMatchIndex] = useState<number>(0);

  const onResults = useCallback(
    (highlights: ReadonlyArray<Element>) => {
      clearFocused(highlights);
      setHighlightedElements(highlights);
      if (highlights.length === 0) {
        return;
      }

      if (highlights.length > 0 && highlights.length <= matchIndex) {
        setMatchIndex(0);
        setFocusOnElement(highlights, highlights[0]);
      } else {
        setFocusOnElement(highlights, highlights[matchIndex]);
      }
    },
    [setHighlightedElements, matchIndex],
  );

  const goToNextMatch = useCallback(() => {
    let newVal = matchIndex + 1;
    if (newVal >= highlightedElements.length) {
      newVal = 0;
    }
    setMatchIndex(newVal);
    setFocusOnElement(highlightedElements, highlightedElements[newVal]);
  }, [setMatchIndex, highlightedElements, matchIndex]);

  const goToPreviousMatch = useCallback(() => {
    let newIndex = matchIndex - 1;
    if (newIndex < 0) {
      newIndex = highlightedElements.length - 1;
    }

    setMatchIndex(newIndex);
    setFocusOnElement(highlightedElements, highlightedElements[newIndex]);
  }, [setMatchIndex, matchIndex, highlightedElements]);

  return {
    onResults,
    goToNextMatch,
    goToPreviousMatch,
    matchIndex,
    numberOfMatches: highlightedElements.length,
  };
};

const goToElement = (element: Element) => {
  if (!isElementVisible(element)) {
    scrollIntoView(element);
  }
};
const setFocusOnElement = (elements: ReadonlyArray<Element>, element: Element) => {
  clearFocused(elements);
  setFocusedAttribute(element);
  goToElement(element);
};
